import Swiper, { Navigation, Pagination, Grid, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Grid, Autoplay]);
import home  from '../home.js'
 

const custom = {
  config: {
    // Seletor do botão de comprar
    selectorBtnBuyAssinatura: '[data-action="add-cart-assinatura"]',
    // Seletor do elemento que engloba um produto
    selectorWrapperProductAssinatura: '[data-box-produto-assinatura]',
    selectorFormProductAssinatura: '[data-form-product-assinatura]',
  },
  setCategoryIcons: () => {
    let slider = document.querySelector("[data-category-icons]");
    if (slider) {
      let init = new Swiper(slider, {
      
        slidesPerView: 4,
        spaceBetween: 1,
        watchOverflow: true,
        passiveListeners: true,
        
        allowSlideNext: false,
        allowSlidePrev: false,

        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 1
          },
        }
      });
    }
  },
  setCategoryIconsMiddle: () => {
    let slider = document.querySelector("[data-category-icons-middle]");
    if (slider) {
      let init = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 1,
        watchOverflow: true,
        passiveListeners: true,

        allowSlideNext: false,
        allowSlidePrev: false,
        
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 1
          },
        }
      });
    }
  },
  setCategoryIconsBottom: () => {
    let slider = document.querySelector("[data-category-icons-bottom]");
    if (slider) {
      let init = new Swiper(slider, {
        keyboardControl: true,
        slidesPerView: 3,
        spaceBetween: 20,
        watchOverflow: true,
        passiveListeners: true,
        autoplay: {
          enabled: window.innerWidth < 768 ? true : false,
          delay: 4000,
        },
        loop: window.innerWidth < 768 ? true : false,
        speed: 1100,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,   
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          },
        }
      });
    }
  },
  setCustomTabs: function () {
    $(".section-tabs .head").on("click", function(){
      let tabContainer = $(this).parent(".tab-item");
      let tabBody = $(tabContainer).find(".content");

      $(tabBody).slideToggle().toggleClass("active")
      $(this).toggleClass("active")
    })

    $(document).ready(function () {
      if(location.hash != null && location.hash != "") {
        var offsetTop = $(location.hash).offset().top;
        $(location.hash).find('.head').trigger("click")
        window.scroll({
          top: offsetTop - 100,
        });
      }
    });
  },

  addItemAssinatura: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find(custom.config.selectorBtnBuyAssinatura);
    var url = window.urlAssinaturaCartAdd 
    
    var $boxResponse = _$parent.find(custom.config.selectorFormProductAssinatura + ' .msg-response:not(.resp-validate)');
    var data = {};

    data.subscription_item = {
      quantity: _$form.find('[name="quantity"]').val(),
      sku: _$form.find('[name="sku"]').val(),
      extra: {
        vindi_plan_id: _$form.find('[name="extra[vindi_plan_id]"]').val()
      }
    }

    if (!$btnComprar.hasClass('adding')) {
      $.ajax({
        url: url,
        type: 'POST',
        // dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
        xhrFields: { withCredentials: true },
        beforeSend: function () {
          $btnComprar.addClass('adding');
        }
      })
      .done(function (resp) {
        console.log("success");
        console.info(resp);

        if (typeof _this.addItemResultAssinatura == 'function') {
          _this.addItemResultAssinatura(_$form, 'produto-adicionado', resp, $boxResponse);
        } else {
          custom.addItemResultDefaultAssinatura(_$form, 'produto-adicionado', resp, $boxResponse);
        }
      })
      .fail(function (xhr, status, error) {
        console.log("error");

        var resp = {
          error: 'Houve um problema ao adicionar.' + '<br>' + 'Tente mais tarde ou entre em contato.',
        }

        var $boxResponse = $('#erro-adicionar-assinatura');         

        if (typeof _this.addItemResultAssinatura == 'function') {
          _this.addItemResultAssinatura(_$form, 'erro-adicionar', resp, $boxResponse);
          
        } else {
          custom.addItemResultDefaultAssinatura(_$form, 'erro-adicionar', resp, $boxResponse);
        }
      })
      .always(function () {
        console.log("complete");
        $btnComprar.removeClass('adding');
      });    
    }
  },

  //AJEITAR ISSO, ESSA FUNÇÃO TEM IGUAL NO INFO.JS, BASTA ADICONAR A PARTE DE ASSINATURA LA 
  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest('[data-box-produto]');
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    if ($btnComprar.data('available') == 'false') {
      validated = false;
      errorsTxt.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (_$form.find('[name="sku"]').val() == '') {
        validated = false;
        if (_$form.is('[data-form-product-assinatura]')){
          errorsTxt.push('Selecione uma assinatura');
        } else {
          errorsTxt.push('Selecione um atributo para o produto');
        }
      }

      //  verifica se a quantidade é válida
      if (_$form.find('input[name="quantity"]').val() <= 0) {
        console.log("qtd invalida");
        validated = false;
        errorsTxt.push('Quantidade indisponível');
      }
    }

    return {validated: validated, errors: errorsTxt};
  },
  addItemResultDefaultAssinatura: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuyAssinatura);

      $btnComprar.addClass('success').html('Adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 300);
      setTimeout(function () {
        window.location.href = window.urlAssinaturaCart;
      }, 100);

    } else if (_typeResult == 'erro-adicionar') {
      if (typeof _result == 'object') {
        var errorText = _result;
      } else {
        var errorText = JSON.parse(_result);
      }

      if (typeof (_$boxResponse) != 'undefined' && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);
      }
    }
  },

  init: function () {
    this.setCategoryIcons();
    this.setCategoryIconsMiddle();
    this.setCategoryIconsBottom();
    this.setCustomTabs();
    home.setBannerRotative();

    $('.category-tabs .links a').on('click', function (e) {
      e.preventDefault();
      $('.category-tabs .links a').removeClass('active');
      $(this).addClass('active');
      var tag = $(this).attr('href');
      $('.category-tabs .item').removeClass('active');
      $('[data-link="' + tag + '"]').addClass('active');
    });

    var $form_assinatura = $('[data-form-product-assinatura]');
    var $product_assinatura = $('[data-item-assinatura]');   
    var sku_input_form = $form_assinatura.find('input[name="sku"]');
    var vindi_id_input_form = $form_assinatura.find('input[name="extra[vindi_plan_id]"]');

    $product_assinatura.on( 'click', function() {
      var input_sku = $(this).children('input[name="sku"]');
      var input_vindi_id = $(this).children('input[name="extra[vindi_plan_id]"]');

      var selected_sku = input_sku.val();
      var selected_vindi_id = input_vindi_id.val();

      sku_input_form.attr('value',selected_sku);
      vindi_id_input_form.attr('value',selected_vindi_id);

      $form_assinatura.addClass('active');

    });
    

    $(document).on('submit', custom.config.selectorFormProductAssinatura, function (event) {
      event.preventDefault();

      var $form = $(this);
      var $parent = $form.closest(custom.config.selectorWrapperProductAssinatura);

      var $btnComprar = $parent.find(custom.config.selectorBtnBuyAssinatura);
      var formData;

      var respValidated = custom.validateFormProduct($form);
      var $boxResponse = $parent.find('.resp-validate');


      if (respValidated.validated) {
        custom.addItemAssinatura($form, $parent);
      } else {
        console.info('não foi');
        // custom.setRespValidateProduct(respValidated, $form, $boxResponse);
      }
    });

  },
};

export default custom;
